import styled from 'styled-components';

const Card = styled.div.attrs({
    className: 'card',
})`
    background: var(--white);
    padding: 24px 32px;
    border-radius: var(--borderRadiusLg);
    box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
    position: relative;


    &.bordered:before {
        content: '';
        position: absolute;
        top: -1.5px;
        left: -1.5px;
        bottom: -1.5px;
        right: -1.5px;
        border-radius: var(--borderRadiusLg);
        z-index: -1;
        background: linear-gradient(
                153.06deg,
                rgba(255, 0, 140, 0.3) -0.31%,
                rgba(100, 37, 191, 0.3) 99.69%
            ),
            linear-gradient(0deg, #ffffff, #ffffff);
    }
`;

export default Card;
